import React from 'react';
import classNames from 'classnames';
import styled, { ThemeContext } from 'styled-components';
import Swiper from 'react-id-swiper';
import { Img } from 'react-image';
import { SectionName, SectionTitle } from '../common/styles';

const texts = [
  { name: 'Togetherness', desc: 'We’re more powerful together' },
  { name: 'Openness', desc: 'Be real and share our knowledge' },
  { name: 'Growth', desc: 'We’re continously innovating and improving' },
  { name: 'Trust', desc: 'High integrity in everything we do' },
];

const Container = styled.div`
  width: 100vw;
  height: 660px;
  padding: 130px 0;
  border-bottom-right-radius: 200px;
  border-top-left-radius: 200px;
  background-color: ${props => props.theme.bodyColor};
  display: flex;
  flex-direction: column;
  align-items: center;

  & > .icon-container {
    height: 170px;
    margin-bottom: 32px;
    width: ${props => (props.theme.isMobile ? 100 : 58.9)}vw;
    ${props => !props.theme.isMobile && `
      max-width: 848px;
      display: flex;
      justify-content: space-between;
    `};

    & > .swiper-wrapper {
      display: flex;
    }
  }
`;

const Title = styled(SectionName)`
  margin-bottom: 70px;
`;

const hoverSize = 137;
const imageSize = 101;

const Image = styled(Img)`
  width: ${imageSize}px;
  height: ${imageSize}px;
`;

const Icon = styled.div`
  width: ${hoverSize}px;
  height: ${hoverSize}px;
  text-align: center;
  vertical-align: center;
  border-radius: 10px;
  padding: ${0.5 * (hoverSize - imageSize)}px;

  &.current {
    background-color: ${props => props.theme.primaryColor};
    color: ${props => props.theme.primaryColor};
    box-shadow: 0 3px 20px rgba(0, 0, 0, .16);

    &:after {
      content: "\\25bc";
      position: relative;
      font-size: 20px;
      top: 20px;
    }

    & > ${Image} {
      filter: grayscale(1);
    }
  }
`;

const Name = styled(SectionTitle)`
  color: white;
  margin: 0;
  ${props => props.theme.isMobile && `
    font-size: 35px;
    line-height: 46px;
  `};
`;

const Desc = styled.p`
  text-align: center;
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightBook};
  font-size: ${props => (props.theme.isMobile ? 35 : 40)}px;
  line-height: ${props => (props.theme.isMobile ? 36 : 41)}px;
  color: white;
  margin: ${props => (props.theme.isMobile ? '20px' : 0)};
  margin-top: 15px;
`;

export default function Values() {
  const [index, setIndex] = React.useState(0);
  const [swiper, setSwiper] = React.useState(null);
  const {
    values,
    isMobile,
  } = React.useContext(ThemeContext);
  const swipeOptions = {
    containerClass: 'icon-container',
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 30,
    slideActiveClass: 'current',
    getSwiper: setSwiper,
  };

  React.useEffect(() => {
    if (swiper !== null) {
      swiper.on('slideChange', () => setIndex(swiper.realIndex));
    }
  }, [swiper]);

  function renderIcon({ inSwiper = true } = {}) {
    return (icon, i) => (
      <Icon
        key={icon}
        {...(inSwiper ? {} : {
          className: classNames({ current: i === index }),
          onMouseEnter: () => setIndex(i),
        })}
      >
        <Image src={icon} />
      </Icon>
    );
  }

  return (
    <Container id="values">
      <Title>our core values</Title>
      {
        isMobile
          ? (
            <Swiper {...swipeOptions}>
              {values.map(renderIcon())}
            </Swiper>
          )
          : (
            <div className="icon-container">
              {values.map(renderIcon({ inSwiper: false }))}
            </div>
          )
      }
      <Name>{texts[index].name}</Name>
      <Desc>{texts[index].desc}</Desc>
    </Container>
  );
}
